import { getWeek } from "date-fns";

export const getWeekNumberByDate = (day) => {
  return getWeek(new Date(day)) - 1;
};
